var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", [
    _c("td", [
      _c(
        "a",
        {
          staticClass: "text-black font-sans-bold",
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.editCategory.apply(null, arguments)
            },
          },
        },
        [_vm._v(_vm._s(_vm.category.title))]
      ),
    ]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.category.slug))]),
    _vm._v(" "),
    _c("td", [
      _vm.category.category_group
        ? _c("span", [_vm._v(_vm._s(_vm.category.category_group.title))])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }